// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__+4Kkl","content":"main_content__Y2bqa"};